import { defineRecipe } from "@chakra-ui/react";

const badgeRecipe = defineRecipe({
  // Chakra v2 badge defaults.
  base: {
    px: "1",
    textTransform: "uppercase",
    fontSize: "xs",
    fontWeight: "bold",
    borderRadius: "sm",
  },
  variants: {
    // v3 sizes override the variants' padding; `auto` opts out of them.
    size: {
      auto: {},
    },
    variant: {
      readOnlyProp: {
        bg: "gray.60",
        padding: "4px 18px",
        borderRadius: "6px",
        fontSize: "16px",
        fontWeight: 400,
        color: "brand.black",
      },
      subtle: {
        display: "flex",
        flexDir: "column",
        bg: "grey.5",
        color: "blue.700",
        letterSpacing: "2px",
        fontSize: "12px",
        h: "24px",
        px: "8px",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "4px",
      },
      // Where a field's text came from, e.g. "PSR" next to the field's label.
      source: {
        display: "inline-flex",
        alignItems: "center",
        px: "8px",
        py: "2px",
        borderRadius: "4px",
        bg: "blue.50",
        color: "blue.800",
        fontSize: "11px",
        fontWeight: "bold",
        letterSpacing: "0.06em",
      },
      success: {
        bg: "green.100",
        color: "brand.activeColor",
        letterSpacing: "2px",
        fontSize: "12px",
        display: "flex",
        h: "24px",
        px: "8px",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "4px",
        w: "max-content",
      },
      danger: {
        bg: "red.100",
        color: "brand.primary",
        letterSpacing: "2px",
        fontSize: "12px",
        display: "flex",
        h: "24px",
        px: "8px",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "4px",
        w: "max-content",
      },
    },
  },
  defaultVariants: {
    size: "auto",
  },
});

export default badgeRecipe;
